import React, { useState, Fragment, useEffect, useCallback } from "react";
import { formBtn1, formBtn2 } from "../Utils/CustomClasses";
import { useForm } from "react-hook-form";
import { Dialog, Transition } from "@headlessui/react";
import Error from "../Error/Error";
import { Tooltip } from "antd";
import { useThemeColor } from "../Sidebar/SideBarApi";
import { UploadCSVLeadStatusAPI, } from "../../API/Api";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { downloadCSV } from "../Utils/CommonFuntion";
import ButtonLoader from "../Loader/ButtonLoader";
import { IconFiles } from "@tabler/icons-react";

export default function AddLead2({ edit, filterRecords }) {
    const themeColor = useThemeColor();
    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors },
        setValue,
    } = useForm({
        defaultValues: {
            file: null
        }
    });
    const file = watch('leadCSVupload');
    const [isOpen, setIsOpen] = useState(false);
    const [dragOver, setDragOver] = useState(false);
    const [AssignUsers, setAssignUsers] = useState([]);
    const [csvLoader, setCsvLoader] = useState(false);
    const [manualLoader, setManualLoader] = useState(false);
    const [activeTab, setActiveTab] = useState("csv");
    
    useEffect(() => {
        if (edit) {
            setActiveTab("addManually");
        }
    }, [edit]);

    const excelHeader = [
        "createdAt",
        "firstName",
        "lastName",
        "email",
        "phoneNumber",
        "leadSource",
        "city",
        "pincode",
        "state",
        "product",
        "assigned_to",
        "leadStatus",
        "remark"
    ];

    const toggle = () => {
        setIsOpen(!isOpen);
        reset();
    };

    const onSubmit = async (data) => {
        if (activeTab === "csv") {
            setCsvLoader(true);
            try {
                const file = data.leadCSVupload[0];
                const text = await file.text();
                const rows = text.trim().split("\n");
                if (rows.length <= 1) {
                    toast.error("CSV file is empty");
                    setCsvLoader(false);
                    return;
                }
                const formData = new FormData();
                formData.append("leadCSVupload", file);
                let response = await UploadCSVLeadStatusAPI(formData);
                if (response?.status == 200) {
                    Swal.fire({
                        title: "CSV Upload Result",
                        html: `
                        <p><strong class="text-base-green">Success:</strong> ${response?.data?.data?.successCount
                            } leads added</p>
                        <p><strong class="text-base-red">Failed:</strong> ${response?.data?.data?.failedCount
                            } leads failed</p>
                         <div style="text-align: -webkit-center">
                         ${response?.data?.data?.failedCount > 0
                                ? `<button id="downloadFailedRecords" class="${formBtn1}" style="margin-top: 10px;">Download Failed Records</button>`
                                : ""
                            }
                      </div>
                    `,
                        icon: response?.data?.data?.failedCount > 0 ? "warning" : "success",
                        confirmButtonText: "OK",
                        allowOutsideClick: false, // Ensures clicking outside closes it
                        customClass: {
                            confirmButton: `${formBtn1}`,
                        },
                        preConfirm: () => {
                            Swal.close(); // Explicitly close on OK
                            setCsvLoader(false);
                            toggle();
                            filterRecords();
                            setAssignUsers([]);
                        },
                        didOpen: () => {
                            document
                                .getElementById("downloadFailedRecords")
                                ?.addEventListener("click", () => {
                                    const headersWithFailureReason = [
                                        ...excelHeader,
                                        "failureReason",
                                    ];
                                    const failedData = response?.data?.data?.failedLeads || [];
                                    downloadCSV(
                                        headersWithFailureReason,
                                        failedData,
                                        "Failed_Leads"
                                    );
                                });
                        },
                    });
                }
            } catch (err) {
                console.log("err", err);
                setCsvLoader(false);
            }
        }
    };

    const handleDragOver = useCallback((e) => {
        e.preventDefault();
        setDragOver(true);
    }, []);

    const handleDragLeave = useCallback((e) => {
        e.preventDefault();
        setDragOver(false);
    }, []);

    const handleDrop = useCallback((e) => {
        e.preventDefault();
        setDragOver(false);

        const droppedFile = e.dataTransfer.files[0];
        if (droppedFile) {
            try {
            validateAndSetFile(droppedFile);
        } catch (error) {
            toast.error(error.message || "Invalid file type. Only CSV files are accepted.");
            console.error(error);
        }
        }
    }, []);

    const validateAndSetFile = (selectedFile) => {
        
        const allowedTypes = [
            'text/csv', // .csv
            'application/csv', // .csv
            'text/comma-separated-values', // .csv
            'text/plain' // sometimes CSV files are recognized as plain text
        ];

        const fileExtension = selectedFile?.name.split('.').pop().toLowerCase();
        const isAllowedExtension = ['csv']?.includes(fileExtension);
        

        if (!allowedTypes.includes(selectedFile?.type) && !isAllowedExtension) {
            reset();
            console.log('first====-------')
            // toast.error("Invalid file type. Only CSV files are accepted.");
            throw new Error('Please select a valid CSV file (.csv)');
        }

        if (selectedFile?.size > 5 * 1024 * 1024) {
            reset();
            // toast.error("File size must be less than 5MB");
            throw new Error('File size must be less than 5MB');
        }

         setValue('leadCSVupload', [selectedFile]);
    };

    const handleFileSelect = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            try {
                validateAndSetFile(selectedFile);
            } catch (error) {
                toast.error(error.message);
                console.error(error);
            }
        }
    };

    return (
        <>
            <>
                <div className="flex ml-2">
                    <button onClick={toggle} className={formBtn1}>
                        Upload Lead Status
                    </button>
                </div>
            </>

            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-[100]" onClose={toggle}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>
                    <div className="fixed inset-0 overflow-y-scroll ">
                        <div className="flex items-center justify-center min-h-full p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-2xl text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                                    <Dialog.Title
                                        as="h2"
                                        className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb"
                                    >
                                        {edit ? "Edit Lead Status" : "Upload Lead Status"}
                                    </Dialog.Title>
                                    <div>
                                        {activeTab == "csv" && (
                                            <div className="absolute right-[2rem]">
                                                <Tooltip
                                                    title={
                                                        <>
                                                            <div>Download demo CSV file here</div>
                                                        </>
                                                    }
                                                    placement="right"
                                                    color="#032037"
                                                >
                                                    <button
                                                        onClick={() => {
                                                            downloadCSV(excelHeader, [], "DemoAddLead");
                                                        }}
                                                    >
                                                        <div className="flex space-x-2 items-center">
                                                            <p>Download CSV file here</p>
                                                            <IconFiles stroke={2} size={32} color={themeColor} className = "cursor-pointer" />
                                                        </div>
                                                    </button>
                                                </Tooltip>
                                            </div>
                                        )}
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div className="flex justify-center items-center">
                                                <div className="p-4 flex flex-col gap-4 items-center">
                                                    <form
                                                        onSubmit={handleSubmit(onSubmit)}
                                                        className="flex flex-col gap-4"
                                                    >
                                                        
                                                <div
                                                    className={`border-2 mt-[15px] border-dashed rounded-xl p-8 text-center transition-all duration-300 ${dragOver
                                                        ? 'border-blue-400 bg-blue-50 scale-105'
                                                        : 'border-gray-300 hover:border-blue-400 hover:bg-blue-50'
                                                        }`}
                                                    onDragOver={handleDragOver}
                                                    onDragLeave={handleDragLeave}
                                                    onDrop={handleDrop}
                                                >
                                                    {file ? (
                                                        <div className="space-y-4">
                                                            <div>
                                                                <p className="text-lg font-medium text-gray-800">{file[0]?.name}</p>
                                                                <p className="text-gray-500">
                                                                    {(file[0]?.size / 1024 / 1024).toFixed(2)} MB
                                                                </p>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                onClick={() => reset()}
                                                                className="text-red-500 hover:text-red-700 font-medium"
                                                            >
                                                                Remove file
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div className="space-y-4">
                                                            <div>
                                                                <p className="text-lg font-medium text-gray-700 mb-2">
                                                                    Drop your CSV file here or click to browse
                                                                </p>
                                                                <p className="text-gray-500">
                                                                    Supports .csv files up to 5MB
                                                                </p>
                                                            </div>
                                                            <input
                                                                type="file"
                                                                accept=".csv"
                                                                {...register('leadCSVupload', {
                                                                    required: 'Please select a file',
                                                                    validate: {
                                                                        fileType: (value) => {
                                                                            if (!value) return true;
                                                                            const allowedTypes = [
                                                                                'text/csv',
                                                                                'application/csv',
                                                                                'text/comma-separated-values',
                                                                                'text/plain'
                                                                            ];
                                                                            const fileExtension = value?.name.split('.').pop().toLowerCase();
                                                                            const isAllowedExtension = ['csv']?.includes(fileExtension);
                                                                            return allowedTypes.includes(value?.type) || isAllowedExtension || 'Invalid file type. Only CSV files are accepted';
                                                                        },
                                                                        fileSize: (value) => {
                                                                            if (!value) return true;
                                                                            return value?.size <= 5 * 1024 * 1024 || 'File size must be less than 5MB';
                                                                        }
                                                                    }
                                                                })}
                                                                onChange={handleFileSelect}
                                                                className="hidden"
                                                                id="file-upload"
                                                            />
                                                            <label
                                                                htmlFor="file-upload"
                                                                className="inline-block bg-base-color text-white px-6 py-3 rounded-lg font-medium  transition-colors duration-200 cursor-pointer"
                                                            >
                                                                Select File
                                                            </label>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Error Message */}
                                                {errors?.leadCSVupload && (
                                                    <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg flex items-center space-x-2">
                                                        <span className="text-red-700">{errors?.leadCSVupload?.message}</span>
                                                    </div>
                                                )}
                                                    </form>
                                                </div>
                                            </div>

                                            <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                                                {activeTab === "csv" ? (
                                                    csvLoader ? (
                                                        <ButtonLoader />
                                                    ) : (
                                                        <button
                                                            type="submit"
                                                            className={`${formBtn1} relative px-4 py-2 text-white font-bold rounded-lg flex items-center justify-center`}
                                                        >
                                                            <span className="opacity-100">Upload</span>
                                                        </button>
                                                    )
                                                ) : manualLoader ? (
                                                    <ButtonLoader />
                                                ) : (
                                                    <button
                                                        type="submit"
                                                        className={`${formBtn1} relative px-4 py-2 text-white font-bold rounded-lg flex items-center justify-center`}
                                                    >
                                                        <span className="opacity-100">
                                                            {edit ? "Update" : "Submit"}
                                                        </span>
                                                    </button>
                                                )}
                                                <button
                                                    type="button"
                                                    className="w-auto lg:px-8 px-4 transition-colors font-tb tracking-wide duration-200 py-2.5 overflow-hidden text-base font-semibold text-center text-base-color border-2 border-base-color rounded-lg hover:text-white hover:bg-[var(--bg-base-color)] capitalize"
                                                    onClick={toggle}
                                                >
                                                    Close
                                                </button>
                                            </footer>
                                        </form>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}
